import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";

const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalGameDeposits: 0,
  data: [],
  filters: {},
  approving: {},
  loading: false,
  error: null,
};

const DepositsSlice = createSlice({
  name: "gamedeposits",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload.gamedeposits;
      state.totalGameDeposits = action.payload.totalGameDeposits;
      state.loading = false;
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateDeposit: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
        state.approving = {};
      }
    },
    setApproving: (state, action) => {
      state.approving = action.payload;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  requestStart,
  ApiSuccess,
  requestFailure,
  setFilters,
  setPage,
  setRowsPerPage,
  updateDeposit,
  setApproving,
} = DepositsSlice.actions;

export const GetGameDeposits = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(
      `/private/backend/gamedeposits?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );

    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
export const PostGameDeposits = (data) => async (dispatch) => {
  try {
    dispatch(setApproving(data));
    const response = await axios.post(`/private/backend/gamedeposits`, data);
    dispatch(updateDeposit(response.data));
    toast.success("Deposit approved successfully");
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(setApproving({}));
  }
};

export default DepositsSlice.reducer;
